
      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $800sp = parcelRequire("800sp");

var $ilwiq = parcelRequire("ilwiq");

var $eV4ey = parcelRequire("eV4ey");

var $i6UHQ = parcelRequire("i6UHQ");
class $30486587a1202a7f$var$ThreeDModel extends (0, $eV4ey.default) {
    constructor(){
        super();
        this.setupScene = this.setupScene.bind(this);
        this.white = new $ilwiq.Color().setHex((0, $i6UHQ.default).white);
        this.light_pink = new $ilwiq.Color().setHex((0, $i6UHQ.default).light_pink);
        this.bright_pink = new $ilwiq.Color().setHex((0, $i6UHQ.default).bright_pink);
        this.dark_grey = new $ilwiq.Color().setHex((0, $i6UHQ.default).dark_grey);
        this.highlight = this.parentElement;
        this.width = 100;
        this.height = 100;
    }
    render() {
        return (0, $800sp.html)`
    <div id="container" ></div>
    `;
    }
    async firstUpdated() {
        // Give the browser a chance to paint
        await new Promise((r)=>setTimeout(r, 0));
        this.init();
        const link = this.getAttribute('link');
        const geometry = await this.getModel(link);
        const material = new $ilwiq.MeshPhongMaterial({
            color: this.dark_grey,
            flatShading: true,
            shininess: 0
        });
        this.mesh = new $ilwiq.Mesh(geometry, material);
        this.setupLights();
        this.setupScene();
        this.startAnimation();
    }
    setupLights() {
        this.scene.background = new $ilwiq.Color(this.light_pink);
        this.camera = new $ilwiq.OrthographicCamera(this.width / -2, this.width / 2, this.height / 2, this.height / -2, 0, 1000);
        this.scene.add(this.mesh);
        this.mesh.scale.set(8, 8, 8);
        this.mesh.position.set(0, 0, -100);
        const light_one = new $ilwiq.SpotLight(this.white, 1.5);
        light_one.position.set(0, 10, 10);
        this.scene.add(light_one);
        const light_two = new $ilwiq.HemisphereLight(this.white, this.bright_pink, 3);
        light_two.position.set(0, 1, 0);
        this.scene.add(light_two);
    }
    setupScene() {
        this.renderer.setPixelRatio(window.devicePixelRatio);
        this.renderer.setSize(this.width, this.height);
        this.container?.appendChild(this.renderer.domElement);
        this.renderer.setAnimationLoop(this.startAnimation);
    }
    startAnimation() {
        let hover = this.highlight.matches(':hover');
        let focus = this.highlight.matches(':focus');
        const material = this.mesh.material;
        if (hover || focus) {
            material.color.setHex((0, $i6UHQ.default).light_pink);
            material.shininess = 100;
        } else material.color.setHex((0, $i6UHQ.default).dark_grey);
        let timer = Date.now() * 0.0005;
        this.mesh.rotation.x = Math.sin(timer);
        this.mesh.rotation.y = Math.cos(timer);
        this.renderer.render(this.scene, this.camera);
    }
}
window.customElements.define("three-d-model", $30486587a1202a7f$var$ThreeDModel);


//# sourceMappingURL=statement.0db71ebf.js.map
